import { forwardRef } from "react";

import { FormField, useFormContext } from "@ui/components/Form";
import { Select } from "@ui/components/Inputs/Select";
import { TextInput } from "@ui/components/Inputs/TextInput";

import type { DateInputProps } from "../../BirthDateFormInputs";

import styles from "../../BirthDateFormInputs.module.scss";

export const DAY_INPUT_MAX_LENGTH = 2 as const;

export const DayInput = forwardRef<HTMLInputElement, DateInputProps>(
  ({ placeholder, ariaLabel, type, onKeyUp }, dayInputRef) => {
    const { formState } = useFormContext();
    if (type === "select") {
      return (
        <FormField
          name="day"
          validation={{
            required: true,
          }}
          ref={dayInputRef}
          className={styles.selectInput}
          render={({ field }) => (
            <Select
              {...field}
              options={Array.from({ length: 31 }, (_, i) => ({
                value: String(i + 1),
                label: String(i + 1),
              }))}
              menuPosition="fixed"
              placeholder={placeholder}
              aria-label={ariaLabel}
              dataTestId="day-input"
              isError={!!formState.errors.day}
              isSearchable={false}
              required
            />
          )}
        />
      );
    }
    return (
      <FormField
        name="day"
        validation={{
          required: true,
          validate: {
            dateValid: (day) => day >= 1 && day <= 31,
          },
        }}
        render={({ field }) => (
          <TextInput
            maxLength={DAY_INPUT_MAX_LENGTH}
            placeholder={placeholder}
            aria-label={ariaLabel}
            {...field}
            type="text"
            inputMode="numeric"
            data-testid="day-input"
            ref={dayInputRef}
            onKeyUp={onKeyUp}
            isError={!!formState.errors.day}
          />
        )}
      />
    );
  }
);
